import { network } from 'services/network';

import { QueryParams } from 'api/mutations/createSegment.mutation';

export const createSegment = (params: QueryParams) => {
    return network.post('api/bo/createSegment', params).then((response) => {
        return response.data;
    });
};
